var _defs, _rect, _path, _rect2, _text, _path2, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "130px",
    height: "144px",
    viewBox: "-0.5 -0.5 130 144",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-12-25T03:56:54.519Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36\" etag=\"sF7WAqbe9iuLUP1d8vIS\" version=\"16.1.0\"><diagram id=\"D8fbLzI3vx-b_w3Sd3WI\" name=\"Page-1\">7VbBjpswEP0ajhsZHJzkuMludltppag5tD264IC1BlPjJKRfXxuGGIekaqtu1UO54HkznrFn3gwEeFU0T4pW+YtMmQgilDYBfgiiKAwRMS+LnDokxtMOyBRPwcgBW/6NAYgA3fOU1Z6hllJoXvlgIsuSJdrDqFLy6JvtpPCjVjRjI2CbUDFGP/JU5x06j5HDnxnPcn2+MGi+0OQ1U3JfQrxSlqzTFLR3A6Z1TlN5HED4McArJaXuVkWzYsKmtc9Yt299Q3s+smKl/pkN8XN0KCpUz08v+Wz9/H717sPmbt55OVCxh1TAYfWpz017O2adoAAvjznXbFvRxGqPhg0Gy3UhjBSa5U6WGsobRgiAlRRStc4wQsslsnitlXxltzV9GRYGGd8ULn9gSrNmAMHNn5gsmFYnY+Io2m0Bgi7iTjy6aod9ofJBpQlgFAiWnT27TJsFJPsXEt+f50eZZ2V6b8ltpJZXXqb9srCG6092PUFzDPLnVg7JDOSHZmD8cBoIG6a4uRZTgI1LcLtcN4vDUq/nxqUZ5D6+kvoeU0xQzQ9+p16rB0TYSG5O4iofkQlxzyzyeBCG8QTNpnM8i5F9wpnvv5Z7lTBwOWyuyygEXfr1HWmqMqZHjkx96WlgVlmDesSuc9Z+n3CLK3wjQkOL2tlNNb2z67taJa0F+bq3w8mwTts5fG/PFK2tST3JpMwEoxWvJ4ksDJzUxmS9owUXNgfbNnFBtFyZj4V5bZR0Dj2a92AXup0dJhIy7Vg13pbkzD4HGh4SYoexg0jWvaf9/eDMTnPRZmaE6BHFoeF2XIgL6Pq0M+FABsdWb+cTN1+Ze8Gz0mAFT1OrXFIAEtM0tuv+yIibxh4Fe0YO2mxxpc1C/GYjLv4/4v6FEYfJ24w4TP7aiDOi+1HqzN2PKH78Dg==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(https://fonts.googleapis.com/css?family=Source+Code+Pro);&#xa;"))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 120,
    height: 60,
    fill: "rgb(255, 255, 255)",
    stroke: "#00bb00",
    strokeWidth: 9,
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20.67 62.07 L 54 62",
    fill: "none",
    stroke: "#00bb00",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 7,
    width: 90,
    height: 130,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 72,
      marginLeft: 84
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    "data-font-src": "https://fonts.googleapis.com/css?family=Source+Code+Pro",
    style: {
      fontSize: 120
    },
    color: "#006600"
  }, "$"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 79,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "24px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "$")))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.67 83.07 L 54 83",
    fill: "none",
    stroke: "#00bb00",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca7208cb1fb7fa55553351c7581f10b0.svg";
export { ForwardRef as ReactComponent };